import { z } from 'zod';
/**
 * Shared voicemail-handling knobs used by any action or node that places an
 * outbound dial — currently the Transfer action's briefing leg, next the
 * start-call node. Defaults are the sensible always-on behavior: detect
 * voicemail, leave the shared default message.
 */
export const VoicemailSettingsSchema = z.object({
    /** On: run AMD so a detected machine fires the voicemail outcome. */
    voicemailDetectionEnabled: z.boolean().default(true),
    /** On: leave `voicemailMessage` at the beep. Off: decline silently. */
    leaveVoicemailEnabled: z.boolean().default(true),
    /** Exact message to leave. Null falls back to the shared default. */
    voicemailMessage: z.string().nullable().default(null),
});
//# sourceMappingURL=voicemail-settings.js.map